import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const activitySearchContext = createContext();

export const ActivitySearchProvider = ({ children }) => {
  const [primaryCourseFilters, setPrimaryCourseFilters] = useState([]);
  const [courseLoading, setCourseLoading] = useState(false);
  const [questionsTabBasicCourse, setQuestionsTabBasicCourse] = useState([]);
  const [questionsTabBasicGradeIds, setQuestionsTabBasicGradeIds] = useState([]);
  const [questionsTabAdvMathCourses, setQuestionsTabAdvMathCourses] = useState([]);
  const [questionsTabAdvSocialStudiesCourses, setQuestionsTabAdvSocialStudiesCourses] = useState([]);
  const [questionsTabAdvScienceCourses, setQuestionsTabAdvScienceCourses] = useState([]);
  const [questionsTabAdvELACourses, setQuestionsTabAdvELACourses] = useState([]);
  const [questionsTabAdvForeignLanguageCourses, setQuestionsTabAdvForeignLanguageCourses] = useState([]);
  const [questionsTabAdvOtherCourses, setQuestionsTabAdvOtherCourses] = useState([]);
  const [examsTabSelectedGrades, setExamsTabSelectedGrades] = useState([]);
  const [examsTabSelectedCourses, setExamsTabSelectedCourses] = useState([]);
  const [examsTabSelectedStates, setExamsTabSelectedStates] = useState([]);
  const [examsTabSelectedExamYears, setExamsTabSelectedExamYears] = useState([]);
  const [questionsTabAdvSelectedCourseIds, setQuestionsTabAdvSelectedCourseIds] = useState([]);
  const [resetQuestions, setResetQuestions] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [apiIdentifier, setApiIdentifier] = useState('');
  const [apiParams, setApiParams] = useState({});
  const [courseFilters, setCourseFilters] = useState([]);
  const [levelFilters, setLevelFilters] = useState([]);
  const [publicAssignmentFilters, setPublicAssignmentFilters] = useState([]);
  const [personalAssignmentFilters, setPersonalAssignmentFilters] = useState([]);
  const [topicFilters, setTopicFilters] = useState([]);
  const [topicFiltersApplied, setTopicFiltersApplied] = useState(false);
  const [showClassicCoursesToggle, setShowClassicCoursesToggle] = useState(true);
  const [showClassicCourses, setShowClassicCourses] = useState(false);
  const [contentAreaFilters, setContentAreaFilters] = useState([]); 
  const [activityName, setActivityName] = useState('');
  const [selectedTab, setSelectedTab] = useState(1);

  const gradeFilterOptions = [
    {
      id: 1,
      name: 'K',
      gradeId: [0],
      isChecked: false
    },
    {
      id: 2,
      name: '1',
      gradeId: [1],
      isChecked: false
    },
    {
      id: 3,
      name: '2',
      gradeId: [2],
      isChecked: false
    },
    {
      id: 4,
      name: '3',
      gradeId: [3],
      isChecked: false
    },
    {
      id: 5,
      name: '4',
      gradeId: [4],
      isChecked: false
    },
    {
      id: 6,
      name: '5',
      gradeId: [5],
      isChecked: false
    },
    {
      id: 7,
      name: '6',
      gradeId: [6],
      isChecked: false
    },
    {
      id: 8,
      name: '7',
      gradeId: [7],
      isChecked: false
    },
    {
      id: 9,
      name: '8',
      gradeId: [8],
      isChecked: false
    },
    {
      id: 10,
      name: '9-12',
      gradeId: [9,10,11,12],
      isChecked: false
    }
  ];

  return (
    <activitySearchContext.Provider
      value={{
        primaryCourseFilters,
        setPrimaryCourseFilters,
        courseLoading,
        setCourseLoading,
        questionsTabBasicGradeIds,
        setQuestionsTabBasicGradeIds,
        questionsTabBasicCourse,
        setQuestionsTabBasicCourse,
        questionsTabAdvMathCourses,
        setQuestionsTabAdvMathCourses,
        questionsTabAdvSocialStudiesCourses,
        setQuestionsTabAdvSocialStudiesCourses,
        questionsTabAdvScienceCourses,
        setQuestionsTabAdvScienceCourses,
        questionsTabAdvELACourses,
        setQuestionsTabAdvELACourses,
        questionsTabAdvForeignLanguageCourses,
        setQuestionsTabAdvForeignLanguageCourses,
        questionsTabAdvOtherCourses,
        setQuestionsTabAdvOtherCourses,
        examsTabSelectedGrades,
        setExamsTabSelectedGrades,
        examsTabSelectedCourses,
        setExamsTabSelectedCourses,
        examsTabSelectedStates,
        setExamsTabSelectedStates,
        examsTabSelectedExamYears,
        setExamsTabSelectedExamYears,
        gradeFilterOptions,
        questionsTabAdvSelectedCourseIds,
        setQuestionsTabAdvSelectedCourseIds,
        resetQuestions,
        setResetQuestions,
        isSearching,
        setIsSearching,
        showResults,
        setShowResults,
        apiIdentifier,
        setApiIdentifier,
        apiParams,
        setApiParams,
        courseFilters,
        setCourseFilters,
        levelFilters,
        setLevelFilters,
        publicAssignmentFilters,
        setPublicAssignmentFilters,
        personalAssignmentFilters,
        setPersonalAssignmentFilters,
        topicFilters,
        setTopicFilters,
        topicFiltersApplied,
        setTopicFiltersApplied,
        showClassicCoursesToggle,
        setShowClassicCoursesToggle,
        showClassicCourses,
        setShowClassicCourses,
        contentAreaFilters,
        setContentAreaFilters,
        activityName,
        setActivityName,
        selectedTab,
        setSelectedTab
      }}>
      {children}
    </activitySearchContext.Provider>
  );
};

ActivitySearchProvider.propTypes = {
  children: PropTypes.node
};

export const useActivitySearchContext = () => useContext(activitySearchContext);
